import React from "react";
import "./Css/Navbar.css";
import logo from "./Ellipse 2 (1).png"
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <div className="navbar">
      <div className="navbar-container">

        <div className="navbar-left">
          <img
            src={logo}
            alt="AK Logo"
            className="logo"
          />
          <h2 className="brand-name">AKES Software</h2>
        </div>

        {/* Center Menu */}
        <ul className="nav-menu">
          <li><Link to="/">Home</Link></li>
          <li> <Link to="/about">About </Link></li>
          <li><Link to="/features">Features</Link></li>
          <li> <Link to="/pricing">Pricing </Link></li>

          <li> <Link to="/contact">Contact </Link></li>

        </ul>

        {/* Right Icons */}
        {/* <div className="navbar-right">
          <button
            className="hero-btn"
            onClick={() => window.open("https://institute.akessoft.in", "_blank")}
          > Login
          </button>
        </div> */}

      </div>
    </div>
  );
};

export default Navbar;